import {pageInfo, initPage, initUpdate, editData} from './../api';
import { Message } from 'element-ui';
const notice = {
  namespaced: true,
  state: {
    total:0,
    pageResp:null,
    editResp: null,
    initPageObj: null,
    initUpdateObj: null,
  },
  mutations: {

    PAGE_INFO(state,data){
      state.total = data.total;
      // state.pageResp = data.obj || [];
      state.pageResp = (data.obj || []).map(item => {
        if(item.noticeObj=='10') {
          return {
            ...item,
            noticeObj: '所有人可见'
          }
        } else if(item.noticeObj=='20') {
          return {
            ...item,
            noticeObj: '对内新闻'
          }
        } else if(item.noticeObj=='30') {
          return {
            ...item,
            noticeObj: '对外新闻'
          }
        } else {
          return {
            ...item,
            noticeObj: '所有人可见'
          }
        }
      });
    },
    INIT_PAGE(state,data) {
      state.initPageObj = data.obj || {};
    },
    INIT_UPDATE(state,data) {
      state.initUpdateObj = data.obj || {};
    },
    EDIT_DATA(state,data){
      state.editResp = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //初始化页面事件
    async initPage({commit}, obj){
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //初始化更新对象事件
    async initUpdate({commit}, obj){
      let resp = await initUpdate(obj);
      commit('INIT_UPDATE', resp);
    },
    //修改保存事件
    async editData({commit}, obj){
      let resp = await editData(obj);
      commit('EDIT_DATA', resp);
    },
  }
}
export default notice



// WEBPACK FOOTER //
// ./src/page/bd/notice/store/notice.store.js